<template>
  <footer>
    <div class="logo-container">
      <!--        <a href="https://www.advantest.com/" target="blank" class="logo-wrap">-->
      <!--          <img-->
      <!--              style="height: 18px; margin: 30px 0 55px"-->
      <!--              src="@/assets/shouye/logo_white@2x.png"-->
      <!--              alt=""-->
      <!--          />-->
      <!--          <div>官方网站</div>-->
      <!--        </a>-->
      <div
          class="logo-wrap"
          style="border-left: 1px solid rgba(255, 255, 255, 0.6)"
      >
        <img
            style="height: 80px; margin: 0 0 12px"
            src="@/assets/qrcode.jpg"
            alt=""
        />
        <div style="font-size: 12px;">关注我们</div>
      </div>
    </div>
    <div class="logo-container-center">
      <div class="logo-wrap"
           style="width: 50%;"
      >
        <a href="https://www.advantest.com/" target="blank" class="logo-wrap">
          <div style="margin-left: 85%;font-size: 16px;">官方网站</div>
        </a>
      </div>
      <div class="logo-wrap"
           style="border-left: 1px solid rgb(60, 60, 60);width: 50%;"
      >
        <a @click.stop="showProtocol2 = true" target="blank" class="logo-wrap">
          <div style="margin-right: 85%;font-size: 16px;">隐私政策</div>
        </a>
      </div>
    </div>
    <div class="footer-text">©爱德万测试（中国）管理有限公司</div>
    <div class="footer-text">
      <a
          style="text-decoration: none; color: rgb(93, 93, 93)"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502008601"
      >
        <img src="@/assets/6000000007099-2-tps-20-20.png" alt="" />
        沪公网安备 31011502008601号
      </a>
    </div>
    <div class="footer-text">
      <a
          style="text-decoration: none; color: rgb(93, 93, 93)"
          target="_blank"
          href="https://beian.miit.gov.cn/"
      >
        沪ICP备19002302号-1
      </a>
    </div>
    <PrivateProtocol :visible="showProtocol2" @close="showProtocol2 = false">
    </PrivateProtocol>
  </footer>
</template>

<script>
import PrivateProtocol from "@/views/login/components/private-protocol";

export default {
  name: 'Footer',
  components: {PrivateProtocol},
  data(){
    return{
      showProtocol2: false,
    }
  }
};
</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  margin-top: 0px;
  background: rgba(232, 232, 232,1);
  opacity: 1;
  overflow: hidden;
  padding-bottom: 30px;
  box-sizing: border-box;
  .logo-container {
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    padding-top: 20px;
    margin-bottom: 15px;
    .logo-wrap {
      width: 100%;
      text-align: center;
      color: rgb(12, 90, 31);
      font-size: 16px;
      line-height: 16px;
    }
  }
  .logo-container-center{
    width: 100vw;
    display: flex;
    flex-flow: row;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;
    .logo-wrap {
      width: 100%;
      text-align: center;
      color: rgb(12, 90, 31);
      font-size: 16px;
      line-height: 16px;
    }
  }
  .footer-text {
    text-align: center;
    color: rgb(93, 93, 93);
    font-size: 12px;
    margin-bottom: 2px;
    line-height: 14px;
  }
}
</style>
